import {Basic} from '@packages/systems/core/plugins';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Text Block',
  showEmpty: true,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  style: {
    base: {
      main: {
        noPseudo: {
          fontWeight: 700,
        },
      },
    },
  },
  constraints: {
    ancestors: [{is: 'CommerceCartLineItem', rule: 'ExactlyOne'}],
  },
  render: Atom.getConfigShape(Basic.atoms.Block).render,
  fields: {children: TListOfElement},
});

export default config;
